import StatusGif from "entities/status-gif";
import React from "react";
import StatusSupport from "widgets/status-support";
import { motion } from "framer-motion";

export const ErrorComponent = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      className="gg-flex gg-flex-col"
    >
      <StatusGif
        src="https://media1.giphy.com/media/5GTfTQLOEyJPbNHWcc/giphy.gif"
        alt="Een GewoonGers Gif. Unsuccesful bumbal date"
      />

      <h2 className="gg-mt-4 gg-text-2xl gg-font-bold gg-text-dark-blue md:gg-text-5xl">
        Het inplannen van de afspraak is mislukt!
      </h2>
      <p className="gg-mb-6 gg-mt-5 gg-text-lg">
        Dit kan meerdere redenen hebben. Neem contact op met onze
        klantenservice, zodat we dit voor je kunnen oplossen.
      </p>
      <StatusSupport />
    </motion.div>
  );
};
